import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faList } from "@fortawesome/pro-regular-svg-icons/faList";
import axios from "axios";
import { useConfig } from "@peracto/peracto-config";

let Icon = () => (
    <div className="flex py-10 justify-center items-center w-full">
        <FontAwesomeIcon icon={faList} size="6x" />
    </div>
);

const SubCategoryRenderer = ({
    state: { menuItemPath, menuItem, category = {} },
    isEditMode,
}) => {
    const config = useConfig();
    const API_URL = config.get("api");
    const [menuItemData, setMenuItemData] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [loadingError, setLoadingError] = useState(false);
    const categoryPath = "category";

    const { heading, description, image, path } = category?.value || {};

    useEffect(() => {
        if (menuItemPath) {
            const loadMenuItems = async () => {
                setLoadingError(false);
                const path =
                    menuItemPath[0] === "/"
                        ? menuItemPath.substr(1)
                        : menuItemPath;
                try {
                    axios
                        .get(`${API_URL}/menu-items-children-by-path/${path}`)
                        .then((res) => {
                            const data = res.data && res.data["hydra:member"];

                            if (data) {
                                setMenuItemData(data);
                                setIsLoading(false);
                            }
                        })
                        .catch((error) => {
                            setLoadingError(true);
                            return Promise.reject(error);
                        });
                } catch (e) {
                    console.error(e);
                    setLoadingError(true);
                }
            };

            loadMenuItems();
        }
    }, [API_URL, menuItemPath]);

    if (loadingError) {
        // this has padding so the element is at least clickable so it can be selected and edited
        return <div className="py-10 w-full"></div>;
    }

    const inStorefront = !window?.location?.pathname.includes("/content/edit/");

    console.log(menuItem);

    return (
        <>
            <div className="bg-brand-grey">
                <div className="flex flex-col lg:flex-row max-w-[1440px] lg:px-[15px] mx-auto">
                    <div className="flex-1 order-2 lg:order-1">
                        <div className="flex flex-col gap-y-[30px] lg:gap-y-[60px] py-[15px] lg:py-[30px] px-[20px] lg:pl-0 lg:pr-[30px]">
                            <nav
                                className="whitespace-nowrap text-[14px] leading-[20px]"
                                data-testid="breadcrumb"
                                aria-label="breadcrumb"
                            >
                                <ol className="breadcrumb m-0 list-none p-0">
                                    <li className="inline-flex items-center">
                                        <div data-testid={`breadcrumb__link`}>
                                            <a
                                                href={
                                                    menuItem?.value?.parent
                                                        ?.path
                                                        ? `/${menuItem?.value?.parent?.path}`
                                                        : "/"
                                                }
                                                type="button"
                                                className={
                                                    "font-bold !text-brand-quaternary"
                                                }
                                            >
                                                {menuItem?.value?.parent
                                                    ?.linkText || "Home"}
                                            </a>
                                        </div>

                                        <span
                                            className="mx-2 text-brand-black"
                                            role="presentation"
                                            data-testid={`breadcrumb__separator`}
                                        >
                                            /
                                        </span>

                                        <div data-testid={`breadcrumb__link`}>
                                            <a
                                                href={`/${categoryPath}/${path}`}
                                                type="button"
                                                className={
                                                    "font-normal text-brand-black"
                                                }
                                            >
                                                {heading}
                                            </a>
                                        </div>
                                    </li>
                                </ol>
                            </nav>

                            <div className="flex flex-col gap-y-[15px]">
                                <h2 className="!text-[30px] !leading-[36px] !lg:text-[40px] !lg:leading-[46px] text-brand-black">
                                    {heading}
                                </h2>
                                <p
                                    className="!text-[16px] !leading-[24px] !lg:text-[18px] !lg:leading-[24px] text-brand-black"
                                    dangerouslySetInnerHTML={{
                                        __html: description,
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="flex-1 order-1 lg:order-2">
                        <div className="aspect-[720/350] h-full  relative">
                            <img
                                src={image}
                                alt={heading}
                                className="absolute top-0 left-0 w-full h-full object-cover"
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div className="bg-brand-white">
                <div className="container py-[30px] lg:py-[60px]">
                    <div className="grid grid-cols-2 lg:grid-cols-4 gap-x-[15px] gap-y-[30px] lg:gap-x-[60px] lg:gap-y-[60px]">
                        {menuItemPath ? (
                            <>
                                {menuItemData?.length > 0
                                    ? menuItemData.map((menuItem, index) => {
                                          if (
                                              !menuItem.path ||
                                              menuItem.itemType === "branch"
                                          ) {
                                              return null;
                                          }
                                          let path =
                                              !menuItem.path.startsWith(
                                                  "http"
                                              ) && menuItemPath[0] !== "/"
                                                  ? `/${menuItem.path}`
                                                  : menuItem.path;

                                          if (
                                              menuItem.itemType ===
                                                  "category" &&
                                              !menuItem.path.startsWith(
                                                  `/${categoryPath}/`
                                              )
                                          ) {
                                              path = `/${categoryPath}${path}`;
                                          }

                                          const image =
                                              menuItem.content?.image ||
                                              menuItem.image ||
                                              "/images/placeholder.png";

                                          const decodedImage = image
                                              ?.replaceAll("(", "%28")
                                              ?.replaceAll(")", "%29");

                                          return (
                                              <a
                                                  href={path}
                                                  onClick={(e) => {
                                                      e.preventDefault();
                                                      if (isEditMode) return;

                                                      window.location = path;
                                                  }}
                                                  className="content-menu-items__item flex flex-col !no-underline"
                                                  key={`menu_item_${index}`}
                                              >
                                                  <div
                                                      className="flex flex-col relative gap-[15px]"
                                                      key={`link-row-${index}`}
                                                  >
                                                      <div className="aspect-[285/200]  relative">
                                                          {decodedImage && (
                                                              <img
                                                                  src={
                                                                      decodedImage
                                                                  }
                                                                  className="absolute top-0 left-0 w-full h-full object-cover"
                                                                  alt="Background"
                                                              />
                                                          )}
                                                      </div>

                                                      {menuItem.linkText && (
                                                          <h2 className="!text-[24px] !leading-[30px] lg:!text-[30px] lg:!leading-[36px] text-brand-black mb-0">
                                                              {
                                                                  menuItem.linkText
                                                              }
                                                          </h2>
                                                      )}

                                                      {menuItem.content
                                                          ?.shortDescription && (
                                                          <p
                                                              className="text-brand-black text-[16px] leading-[22px] lg:text-[18px] lg:leading-[24px]"
                                                              dangerouslySetInnerHTML={{
                                                                  __html: menuItem
                                                                      .content
                                                                      ?.shortDescription,
                                                              }}
                                                          ></p>
                                                      )}
                                                  </div>
                                              </a>
                                          );
                                      })
                                    : !isLoading && "No Menu Items"}
                            </>
                        ) : inStorefront ? (
                            <></>
                        ) : (
                            <Icon />
                        )}
                    </div>
                </div>
            </div>
        </>
    );
};

export default SubCategoryRenderer;
